import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { useStock } from '@services/stock';
import { useIsChain } from '@utils/useIsChain';

import { Page, ModernTabContainer, ModernTabContent } from '@nearst/ui';
import ErrorBoundary from '@components/ErrorBoundary';
import ProductDetails from './ProductDetails';
import StockLevelsCard from './StockLevels/StockLevelsCard';
import { ItemNotFound } from '../../errors/NotFound';

import styles from './InventoryItem.module.scss';

const InventoryItem = () => {
	const { barcode, shopId } = useParams();
	let navigate = useNavigate();
	const { data: stockItem } = useStock(barcode, shopId, { suspense: true });
	const isChain = useIsChain();
	const location = useLocation();

	useEffect(() => {
		document.title = `Product page - ${stockItem?.title || barcode}`;
	}, [barcode, stockItem?.title]);

	if (!stockItem) {
		return <ItemNotFound />;
	}

	return (
		<>
			<Page.Header>
				<Page.BackButton className={styles.backButton} onClick={() => navigate(-1)}>
					Inventory
				</Page.BackButton>
				<h1>{barcode}</h1>
				<p>Edit product information and configure visibility across enabled channels.</p>
			</Page.Header>
			<Page.Section>
				{isChain ? (
					<ModernTabContainer
						tabTitles={[<span key="product-details">Product details</span>, <span key="stock-levels">Stock levels</span>]}
						navigate={navigate}
						location={location}
					>
						<ModernTabContent key="product-details">
							<ErrorBoundary>
								<ProductDetails />
							</ErrorBoundary>
						</ModernTabContent>
						<ModernTabContent key="stock-levels">
							<ErrorBoundary>
								<StockLevelsCard />
							</ErrorBoundary>
						</ModernTabContent>
					</ModernTabContainer>
				) : (
					<ProductDetails />
				)}
			</Page.Section>
		</>
	);
};

export default InventoryItem;
